import React from "react";
import { useState } from 'react';
import { fetchWithAuth } from "../auth"

const AddSensor = ({ isOpen, onClose, gw }) => {

    async function addSensor() {
        await fetchWithAuth('/sensor_gw_add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: idSensorState, type: 0, gw: gw })
        })
            .then(data => {
                setIdSensorState('')
                onClose()
            })
    }

    const [idSensorState, setIdSensorState] = useState('')
    const handleIdSensorChange = (event) => { setIdSensorState(event.target.value) }

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "white",
                    height: 300,
                    width: 480,
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                {/* {children} */}
                <table>
                    <tbody>
                        <tr>
                            <th className="title">Id</th>
                            <th className="title">Tipo</th>
                        </tr>
                        <tr>
                            <td> <input type="text" value={idSensorState} onChange={handleIdSensorChange} /> </td>
                            <td> Vayyar </td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" onClick={addSensor}>
                    Aggiungi
                </button>
                <button type="button" onClick={onClose}>
                    Chiudi
                </button>
            </div>
        </div>
    );
};

export default AddSensor;
